import { Button, Link } from "@heroui/react";
import IconFacebook from "~icons/simple-icons/facebook";
import IconX from "~icons/simple-icons/x";
import IconYoutube from "~icons/simple-icons/youtube";

export function Footer() {
  return (
    <footer className="flex flex-col lg:flex-row gap-4 py-8 lg:py-2 lg:px-8 items-center bg-[#193448] *:!text-[#A7D8FCAF] isolate">
      <Link href="#">Contact Support</Link>
      <Link href="#">Terms of Service</Link>
      <Link href="#">Privacy Policy</Link>
      <div className="flex-1" />
      <div>
        <Button variant="light" isIconOnly>
          <IconYoutube color="#A7D8FCAF" />
        </Button>
        <Button variant="light" isIconOnly>
          <IconFacebook color="#A7D8FCAF" />
        </Button>
        <Button variant="light" isIconOnly>
          <IconX color="#A7D8FCAF" />
        </Button>
      </div>
      <span>&copy; 2024 Turnstile. All rights reserved.</span>
    </footer>
  );
}
